import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import LocationSelector from './../ProductDetail/LocationSelector';
import ProductImages from './../ProductDetail/ProductImages';
import QuantityBox from './../ProductDetail/QuantityBox';
import QuantityInput from './../ProductDetail/QuantityInput';

// import DealerInfo from '../../components/DealerInfo/DealerInfo';
import { ExternalLink, InternalLink } from '../../components/form-elements/Link';
import { addProduct } from '../../../modules/actions/standort/session/cart';
import TireInformationModal from '../../components/Tires/TireInformationModal';
import TireEnergyLabelLinks from '../Tires/TireEnergyLabelLinks';
import StandortRedirect from '../../components/VHost/StandortRedirect';
import { toast } from '../../../helpers/toastHelper';
import { saveproduct, resetproduct } from '../../../modules/actions/productID';
import Button from '../../components/form-elements/Button';
import { trackEvent } from '../../components/Tracking/Matomo';
import { getActiveSalesPrice } from '../../../helpers/productHelper';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';

function MerklistenProductDetail({ product, categoryUrl, productUrl }) {
    const { selectedVariantId } = product;

    const headline = useRef(null);

    const dispatch = useDispatch();
    const history = useHistory();

    const [plz, setPlz] = useState('');
    const [showMap, setShowMap] = useState(false);
    const [selectedQuantityBox, setSelectedQuantityBox] = useState(product.selectedLieferweg);
    const [quantityValue, setQuantityValue] = useState(1);
    const markenStandort = useSelector(markenStandortSelector);

    useEffect(() => {
        if (product.selectedLieferweg) {
            setSelectedQuantityBox(product.selectedLieferweg);
        }
    }, [product.selectedLieferweg]);

    const variant = useMemo(() => {
        if (!_.isEmpty(product.varianten)) {
            return product.varianten.find(v => v._id === selectedVariantId) || product.varianten[0];
        }
        return undefined;
    }, [product, selectedVariantId]);

    if (variant.marketingText.includes('https://media0.autoteileplusservice.de')) {
        variant.marketingText = variant.marketingText.replace('https://media0.autoteileplusservice.de', 'https://techno-images.s3.eu-central-1.amazonaws.com')
    }

    const soldOut = useMemo(() => {
        if (!variant) return false;

        return (
            (variant.isOwnArticle && variant.stockkeeping && variant.stock < 1 && variant.stock !== null) ||
            (!variant.isOwnArticle && variant.stock < 1) ||
            variant.soldOut
        );
    }, [variant]);

    const deliveryTime = useMemo(() => {
        if (!variant) return false;

        const { deliveryDaysFrom, deliveryDaysTo } = variant;

        if (deliveryDaysFrom > 0 && deliveryDaysTo > 0) {
            return `${deliveryDaysFrom}-${deliveryDaysTo} Werktage`;
        }

        if (deliveryDaysFrom > 0) {
            return `${deliveryDaysFrom} Werktage`;
        }

        if (deliveryDaysTo > 0) {
            return `${deliveryDaysTo} Werktage`;
        }

        return '3-5 Werktage';

    }, [variant]);

    const pickupTime = useMemo(() => {
        if (!variant) return false;

        const { pickupDaysFrom, pickupDaysTo } = variant;

        if (pickupDaysFrom > 0 && pickupDaysTo > 0) {
            return `${pickupDaysFrom}-${pickupDaysTo} Werktage`;
        }

        if (pickupDaysFrom > 0) {
            return `${pickupDaysFrom} Werktage`;
        }

        if (pickupDaysTo > 0) {
            return `${pickupDaysTo} Werktage`;
        }

        return '3-5 Werktage';

    }, [variant]);

    useEffect(() => {
        if (variant) {
            let productID;
            if (variant.isOwnArticle) {
                productID = variant.shownId || variant._id;
            } else {
                productID = variant.id;
            }
            dispatch(saveproduct(productID));
        }
    }, [dispatch, variant]);

    useEffect(() => {
        const unlisten = history.listen((location, action) => {
            dispatch(resetproduct());
        });

        return unlisten;
    }, [dispatch, history]);



    if (product.redirect) {
        toast({ message: product.redirect.message, status: 'warning' });
        return <StandortRedirect to={`/${categoryUrl}`} />;
    }

    const isOil = product.kennzeichnung === 'O' || variant.dangerous === 'oil';
    const isBattery = product.kennzeichnung === 'B' || variant.dangerous === 'battery';
    let isOfferActive = variant.isDeliveryOfferActive || variant.isPickUpOfferActive;

    const handleQuantityInputChange = (newValue) => {
        setQuantityValue(newValue);
    };

    const handleAddToCart = (buttonType) => {
        if (!_.isNil(variant.stock) && variant.stock < quantityValue) {
            window.UIkit.notification(`Maximale Bestellmenge: ${variant.stock}`, {
                status: 'danger',
                pos: 'top-right',
            });
            return
        }
        trackEvent({
            category: 'E-Commerce',
            action: 'Lege-in-Warenkorb',
            label: variant.id || (product.shownId || product.id),
            value: getActiveSalesPrice(variant) * quantityValue * 100,
        });
        dispatch(addProduct({ product: { ...variant, selectedLieferweg: selectedQuantityBox, deliveryDays: selectedQuantityBox.legalType === 'online-kauf' ? deliveryTime : pickupTime, deliveryText: selectedQuantityBox.legalType === 'online-kauf' ? `Lieferzeit: ${deliveryTime}` : `Abholbereit in: ${pickupTime}` }, quantity: quantityValue, buttonType }));
    }

    const to = variant.href || `/${categoryUrl}/${variant.slug || variant.id ||product.id}`;

    return (
        <>
            <div className='uk-section uk-section-default uk-section-small'>
                <div className="uk-grid uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-2@m uk-first-column" data-uk-grid="">
                    <div className="product-images-container">
                        <div data-uk-margin="">
                            <div className="uk-width-1-1 uk-margin-auto uk-position-relative">
                                <div className="product-images-container">
                                    <ProductImages variant={variant} images={variant.images ?? []} isOfferActive={isOfferActive} linkedTo={to}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="product-info-container" ref={headline}>
                        <div className='uk-container' style={{ textAlign: "left" }}>
                            <h2 style={{'font-size': '1.5rem', 'line-height': '1.4;'}}>
                            <InternalLink to={to} modifier="reset">
                                <span dangerouslySetInnerHTML={{ __html: variant.bezeichnung }} aria-label={`Zum Produkt: ${variant.bezeichnung.replace(/<[^>]*>/g, '')}`} />
                            </InternalLink>
                            </h2>
                            <p>Artikelnummer: {variant.shownId || variant.id}</p>
                            {/*  for lieferzeit */}
                            <div className="uk-flex uk-flex-between uk-flex-middle uk-padding-small uk-padding-remove-top uk-padding-remove-left uk-padding-remove-right">
                                {(!variant.soldOut && deliveryTime && selectedQuantityBox.legalType === 'online-kauf') && (
                                    <>
                                        <div className="uk-flex uk-flex-middle">
                                            <span className="uk-icon uk-icon-circle uk-text-success lieferzeit-icon-badge" aria-hidden="true"></span>

                                            <span className="uk-text-small uk-margin-small-left">Lieferzeit {deliveryTime}</span>
                                        </div>
                                    </>
                                )}
                                {!variant.soldOut && pickupTime && selectedQuantityBox.legalType === "reservierung" && (
                                    <>
                                        <div className="uk-flex uk-flex-middle">
                                            <span className="uk-icon uk-icon-circle uk-text-success lieferzeit-icon-badge" aria-hidden="true"></span>

                                            <span className="uk-text-small uk-margin-small-left">Abholbereit innerhalb von {pickupTime}</span>
                                        </div>
                                    </>
                                )}
                                {(variant.freeShipping || variant.shippingCostPerArticle === 0) && (
                                    <>
                                        {(product.selectedLieferweg.legalType === 'online-kauf') && (
                                            <span className="uk-text-small lieferzeit-text" ariaLabel="Informationen zu Versandkosten"><u>versandkostenfrei</u></span>
                                        )}
                                    </>
                                )}

                            </div>
                        </div>
                        <div className="uk-child-width-1-1 uk-grid-small" data-uk-grid="">
                            {(!_.isNil(variant.vk_preis) || !_.isNil(variant.pickup_preis)) || (!markenStandort.isTechno) ? (
                                <>
                                    <QuantityBox
                                        isBattery={isBattery}
                                        lieferweg={product.selectedLieferweg}
                                        variant={variant}
                                        isOfferActive={product.selectedLieferweg.legalType === 'online-kauf' ? variant.isDeliveryOfferActive : variant.isPickUpOfferActive}
                                        isSelected={selectedQuantityBox === product.selectedLieferweg}
                                        onSelect={() => setSelectedQuantityBox(product.selectedLieferweg)}
                                        quantity={quantityValue}
                                    />
                                    {product.additionalPickupLieferweg && (
                                        <QuantityBox
                                            isBattery={isBattery}
                                            lieferweg={product.additionalPickupLieferweg}
                                            variant={variant}
                                            isOfferActive={variant.isPickUpOfferActive}
                                            isSelected={selectedQuantityBox === product.additionalPickupLieferweg}
                                            onSelect={() => setSelectedQuantityBox(product.additionalPickupLieferweg)}
                                            quantity={quantityValue}
                                        />
                                    )}
                                </>
                            ) : (
                                !showMap && markenStandort?.isTechno && (
                                    <LocationSelector
                                        onSubmit={({ zipCode }) => {
                                            setPlz(zipCode);
                                            setShowMap(true);
                                        }}
                                    />
                                )
                            )}
                            <div className="uk-grid-small uk-child-width-1-1 uk-child-width-1-2@s uk-first-column uk-padding-remove-left uk-margin-remove-left" data-uk-grid="">
                                    <div>
                                    {selectedQuantityBox.abcKategorie === 'C' &&
                                        <div className="uk-form-controls">
                                            <QuantityInput initialValue={1} minValue={1} maxValue={(!variant.stock || variant.stock > 3) ? 4 : variant.stock} onChange={handleQuantityInputChange} />
                                        </div>
                                    }
                                    {selectedQuantityBox.abcKategorie !== 'C' &&
                                        <div className="uk-form-controls">
                                            <QuantityInput initialValue={1} minValue={1} maxValue={(!variant.stock || variant.stock > 999) ? 1000 : variant.stock} onChange={handleQuantityInputChange} />
                                        </div>
                                    }
                                </div>
                                <div>
                                    <Button
                                        className={soldOut ? "custom-merkliste-button-qualityBox uk-width-1-1 uk-text-uppercase soldout-theme" : "custom-button-qualityBox uk-width-1-1 uk-text-uppercase"}
                                        type="button" 
                                        aria-label={selectedQuantityBox.legalType === 'online-kauf' ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}
                                        disabled={soldOut || variant.deleted}
                                        onClick={() => handleAddToCart(selectedQuantityBox.legalType === 'online-kauf' ? 'addToCart' : 'reserve')}
                                        ariaDescribedBy={soldOut ? 'soldout-ribbon' : (selectedQuantityBox.legalType === 'online-kauf' ? 'lieferzeit-hinweis' : 'abholbereit-hinweis')}
                                        ariaLabel={selectedQuantityBox.legalType === 'online-kauf' 
                                            ? `Zum Warenkorb hinzufügen: ${variant.bezeichnung.replace(/<[^>]*>/g, '')}` 
                                            : `RESERVIEREN & ABHOLEN: ${variant.bezeichnung.replace(/<[^>]*>/g, '')}`}
                                    >
                                        {selectedQuantityBox.legalType === 'online-kauf' ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}
                                    </Button>
                                </div>
                            </div>
                            <div>
                                {(selectedQuantityBox.abcKategorie === 'C' && variant.stockkeeping) && (
                                    <div className="uk-text-small uk-text-left" style={{ color: 'var(--shop-main)' }}>
                                        Maximale Bestellmenge: {(_.isNil(variant.stock) || variant.stock > 3) ? 4 : variant.stock}
                                    </div>
                                )}
                                {(selectedQuantityBox.abcKategorie !== 'C' && variant.stockkeeping) && (
                                    <div className="uk-text-small uk-text-left" style={{ color: 'var(--shop-main)' }}>
                                        Maximale Bestellmenge: {(_.isNil(variant.stock) || variant.stock > 999) ? 1000 : variant.stock}
                                    </div>
                                )}
                            </div>
                            {/* Variant and for reifen articles */}

                            {variant.articleType === 'reifen' && (
                                <div className='energy-label-box'>
                                    <div className="uk-flex uk-flex-left uk-flex-around@s">
                                        <div className='uk-visible@s uk-text-bold uk-text-large uk-flex uk-flex-center uk-flex-middle uk-width-1-2'>EU-Reifenlabel-Werte</div>
                                        <TireInformationModal tire={variant} adjusted={true} />
                                    </div>
                                    <div data-uk-grid="" className="uk-grid-small uk-child-width-expand@s">
                                        <TireEnergyLabelLinks tire={variant} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {variant.sicherHeitsDatenblatt && (
                    <div className="uk-width-1-1 uk-text-large uk-text-right">
                        <ExternalLink to={`https://www.tibsonline.de/AddvMultimedia/${variant.sicherHeitsDatenblatt}`} ariaLabel="Sicherheitsdatenblatt PDF herunterladen und öffnen">
                            <i className="fa fa-file-pdf-o uk-margin-small-right" aria-hidden="true" />
                            Sicherheitsdatenblatt
                        </ExternalLink>
                    </div>
                )}
                {isOil && (
                    <div className="uk-width-1-1 uk-text-large uk-text-right">
                        <InternalLink to="/altoelHinweis" newTab>
                            <i className="fa fa-file-text-o uk-margin-small-right" aria-hidden="true"  />
                            Hinweis zur Entsorgung von Altöl
                        </InternalLink>
                    </div>
                )}
                {isBattery && (
                    <div className="uk-width-1-1 uk-text-large uk-text-right">
                        <ExternalLink to="https://techno-images.s3.eu-central-1.amazonaws.com/pdfs/EntsorgungBatterie2.pdf" ariaLabel="Hinweis zur Batterieentsorgung PDF herunterladen und öffnen">
                            <i className="fa fa-file-pdf-o uk-margin-small-right" aria-hidden="true" />
                            Hinweis zur Batterieentsorgung
                        </ExternalLink>
                    </div>
                )}
                {variant.documents?.length > 0 && (
                    <ul className="uk-list">
                        {variant.documents
                            .filter(document => !_.isString(document))
                            .map(({ url, description }, i) => {
                                return (
                                    <li key={i}>
                                        <ExternalLink to={url} modifier="reset">
                                            <i className="fa fa-file-pdf-o uk-margin-small-right" aria-hidden="true" ariaLabel="PDF herunterladen und öffnen" />
                                            {description}
                                        </ExternalLink>
                                    </li>
                                );
                            })}
                    </ul>
                )}

                {isBattery && (
                    <div>
                        * Im Zusammenhang mit dem Vertrieb von Fahrzeugbatterien sind wir gemäß § 10 BattGh verpflichtet, je
                        Fahrzeugbatterie ein Pfand in Höhe von 7,50 Euro einschließlich Umsatzsteuer zu erheben. Dies entfällt, wenn Sie
                        beim Kauf Ihre gebrauchte Batterie bei uns entsorgen.
                    </div>
                )}
            </div>
        </>
    );
}

export default MerklistenProductDetail
